import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import styled from 'styled-components';
import { FileDropzone } from '~admin/view/components/ui/form/fields/file/file-dropzone.component';
import { MediaFilename } from '~admin/view/components/ui/form/fields/media-file/media-file-name.component';
import { getAcceptedFileFormats } from '~admin/view/components/ui/form/fields/media/media-overlay/helper/media-upload.helper';
import { MediaType } from '~client/model/media-type';
import { Column } from '~common/components/column.component';

interface Props extends FieldRenderProps<File> {
  label: string;
  mediaType: MediaType;
  onMediaSelected?: (width: number, height: number) => void;
}

export const MediaFileInput: React.FunctionComponent<Props> = ({
  label,
  mediaType,
  input,
  onMediaSelected,
}) => {
  const { value } = input;

  const onImageSelected = (file: File): void => {
    const fileReader = new FileReader();

    fileReader.onload = (): void => {
      const image = new Image();
      image.onload = (): void => {
        const { width, height } = image;
        onMediaSelected?.(width, height);
      };
      image.src = fileReader.result as string;
    };

    fileReader.readAsDataURL(file);
  };

  const onVideoSelected = (file: File): void => {
    const video: HTMLVideoElement = document.createElement('video');
    video.preload = 'metadata';

    video.onloadedmetadata = (): void => {
      const { src, videoWidth, videoHeight } = video;
      window.URL.revokeObjectURL(src);
      onMediaSelected?.(videoWidth, videoHeight);
    };

    video.src = URL.createObjectURL(file);
  };

  const onDropAccepted = (files: File[]): void => {
    input.onChange(files[0]);

    if (mediaType === MediaType.IMAGE) {
      onImageSelected(files[0]);
    } else if (mediaType === MediaType.VIDEO) {
      onVideoSelected(files[0]);
    }
  };

  return (
    <Container>
      <MediaFilename filename={value?.name} label={label} />
      <StyledDropzone
        accept={getAcceptedFileFormats(mediaType)}
        maxFiles={1}
        onDropAccepted={onDropAccepted}
      />
    </Container>
  );
};

const Container = styled(Column)`
  width: 100%;
  border: 2px solid ${(props): string => props.theme.colors.gray.v3};
  border-radius: 16px;
  padding: 16px;
`;

const StyledDropzone = styled(FileDropzone)`
  width: 100%;
`;



// WEBPACK FOOTER //
// ./view/components/ui/form/fields/media-file/media-file-input.component.tsx